import { useContext } from 'react'
import { SettingsContext } from '../../context/settings-context'

const statusComponents = {
    active: ({ theme }) => (
        <div
            className={`status-text d-flex align-items-center gap-1 ${theme === 'dark' ? 'text-white' : 'text-black'}`}
        >
            <span className="status-dot text-success">●</span>
            Active
        </div>
    ),

    tosRequired: ({ theme, clickHandler }) => (
        <div
            onClick={clickHandler}
            className={`status-text d-flex align-items-center gap-2 cursor-pointer ${
                theme === 'dark' ? 'tos-color-dark text-white' : 'tos-color text-black'
            }`}
        >
            <div className={`d-flex align-items-center gap-1 ${theme === 'dark' ? 'tos-dark' : 'tos-light'}`}>
                <span className="status-dot">●</span>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                        stroke="currentColor"
                        strokeWidth="1.5"
                    />
                    <path
                        d="M12 13L12 8"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M12 15.75L12 16"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
                <span className="account-cell">Accept ToS</span>
            </div>
        </div>
    ),

    syncing: ({ theme }) => (
        <div
            className={`status-text d-flex align-items-center gap-1 ${theme === 'dark' ? 'text-white' : 'text-black'}`}
        >
            <span className="status-dot text-warning">●</span>
            Syncing
        </div>
    ),

    mismatch: ({ theme }) => (
        <div
            className={`status-text d-flex align-items-center gap-1 ${theme === 'dark' ? 'text-white' : 'text-black'}`}
        >
            <span className="status-dot text-danger">●</span>
            Error
        </div>
    ),

    inactive: ({ theme }) => (
        <div
            className={`status-text d-flex align-items-center gap-2 ${theme === 'dark' ? 'text-white' : 'text-gray-500'}`}
        >
            <span className="status-dot">●</span>
            Inactive
        </div>
    ),
}

const AdAccountStatus = ({ isSystem, tosAccepted, adAccount, statusMismatch, syncing, tosClickHandler }) => {
    const { theme } = useContext(SettingsContext)

    let DisplayComponent = statusComponents.inactive
    let clickHandler

    if (isSystem) {
        DisplayComponent = statusComponents.active
    } else if (adAccount && syncing) {
        DisplayComponent = statusComponents.syncing
    } else if (adAccount && tosAccepted && !statusMismatch) {
        DisplayComponent = statusComponents.active
    } else if (adAccount && statusMismatch) {
        DisplayComponent = statusComponents.mismatch
    } else if (adAccount && !tosAccepted) {
        DisplayComponent = statusComponents.tosRequired
        clickHandler = tosClickHandler
    }

    return <DisplayComponent theme={theme} clickHandler={clickHandler} />
}

export default AdAccountStatus
